import { isPlatformBrowser } from '@angular/common';
import * as i0 from "@angular/core";
export class BingTrackingService {
    constructor(platformId) {
        this.isBrowser = isPlatformBrowser(platformId);
    }
    trackEvent(category = 'form', transactionId) {
        if (!this.isBrowser)
            return;
        window.uetq = window.uetq || [];
        const payload = {};
        if (category)
            payload.event_category = category;
        if (transactionId)
            payload.transaction_id = transactionId;
        window.uetq.push('event', 'submit_lead_form', payload);
    }
}
BingTrackingService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BingTrackingService_Factory() { return new BingTrackingService(i0.ɵɵinject(i0.PLATFORM_ID)); }, token: BingTrackingService, providedIn: "root" });
